import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useHistory, useLocation } from 'react-router-dom';
import * as qs from 'query-string';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';

const messages = defineMessages({
  thankYou: {
    id: 'buy-credits.thank-you',
    defaultMessage: 'Thank you!',
  },
  firstParagraph: {
    id: 'account.settled-commission-notice.first-paragraph',
    defaultMessage: 'Your invoice is paid soonest if:',
  },
  secondParagraph: {
    id: 'account.settled-commission-notice.second-paragraph',
    defaultMessage: '1. The invoice number you entered is the same as on the invoice you uploaded.',
  },
  thirdParagraph: {
    id: 'account.settled-commission-notice.third-paragraph',
    defaultMessage: '2. The invoiced amount is correct.',
  },
  gotIt: {
    id: 'user-notification-dialog.button',
    defaultMessage: 'Got it',
  },
});

const SettledCommissionNotice = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();
  const { invoiceCommissionCreated } = qs.parse(search);

  const hideDialog = () => history.push(pathname);
  const dialogVisible = !!invoiceCommissionCreated === true;

  return (
    <Dialog visible={dialogVisible} header={formatMessage(messages.thankYou)} onHide={hideDialog}>
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <p>{formatMessage(messages.thirdParagraph)}</p>
      <div className="flex-center">
        <Button type="button" className="p-button-primary" onClick={hideDialog} label={formatMessage(messages.gotIt)} />
      </div>
    </Dialog>
  );
};

export default SettledCommissionNotice;
